<template>
    <a-list-item-meta>
        <a-avatar v-if="!app.mobile" slot="avatar" :src="reply.avatar" shape="square" class="reply-avatar"/>
        <div slot="description" class="reply-main">
            <p class="reply-text">
                <user-link :name="reply.authorname" :id="reply.author"/>:
                {{ reply.content }}
            </p>
            <p class="reply-bottom">
                {{ formatDate(reply.posttime) }}
                <a-button type="link" @click="replyThis()">回复</a-button>
                <a-button v-if="userid == reply.author" type="link" @click="deleteSubpost()">删除</a-button>
                <a-button class="admin-button" v-else-if="hasEditPrivilege" type="link" @click="deleteSubpostByAdmin()">删除</a-button>
            </p>
        </div>
    </a-list-item-meta>
</template>

<script>
import axios from 'axios';
import { createFormData } from '../../utils/utils';
import { checkPrivilege } from '../admin/privilege';
import { mapState } from 'vuex';
import UserLink from '@/components/UserLink.vue';

export default {
    props: {
        reply: Object,
    },
    inject: [ 'app' ],
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        mobile() {
            return this._mobile;
        },
        hasEditPrivilege() {
            return checkPrivilege({ bbs: 1 }, this.userPrivilege);
        },
    },
    methods: {
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        },
        replyThis() {
            this.$emit('reply', this.reply);
        },
        deleteSubpost() {
            const { id: sid } = this.reply;
            this.$confirm({
                title: '确认要删除回复吗？',
                content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                onOk: async() => {
                    const { data } = await axios
                        .post("/backend/bbs/deleteSubpost.php", createFormData({
                            sid
                        }));
                    if (data.code == 0) {
                        this.$message.success('删除成功');
                        window.location.reload();
                    } else {
                        this.$message.error('删除失败');
                    }
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        async deleteSubpostByAdmin() {
            const { id: sid } = this.reply;
            const reason = prompt('确认要删除帖子吗？\n你正在动用管理权限，请给出删除理由', '');
            if (reason !== null) {
                const { data } = await axios
                    .post("/backend/bbs/deleteSubpost.php", createFormData({
                        sid, reason
                    }));
                if (data.code == 0) {
                    this.$message.success('删除成功');
                    window.location.reload();
                } else {
                    this.$message.error('删除失败');
                }
            }
        },
    },
    components: {
        UserLink,
    }
}
</script>

<style lang="less" scope>
.reply-avatar {
    margin-top: 4px;
    @media screen and (max-width: 599px) {
        display: none;
    }
}
.reply-main {
    text-align: left;
    .reply-text {
        color: #666;
        margin: 0;
    }
    .reply-bottom {
        text-align: right;
        margin: 0;
    }
    .ant-btn {
        span {
            margin: 0px;
        }
        padding: 0 6px;
    }
    .admin-button {
        color: grey;
    }
}
</style>